import React from 'react';
import {UserContext} from '../../utils/usercontext';
import {postApi} from '../../utils/functions';

import StripeCards from './stripecards';
import StripePayment from './stripepayment';

import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';

import PaypalCards from './paypalcards';
import PaypalPayment from './stripepayment';


import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

class PaymentModule extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      sdk: {},
      payment: false,

      stripePromise: false,
    };
    this.addPayment = this.addPayment.bind(this);
    this.makePayment = this.makePayment.bind(this);
  }

  async componentDidMount() {

    let params = new URLSearchParams();
		const x = await postApi('/v3/payment/payment', params);
		//console.log(x.data);

    

    let stripePromise = loadStripe(x.data.stripe);

    this.setState({status: true, sdk: x.data, stripePromise});

  }

  addPayment(payment) {
    this.setState({payment});
  }

  async makePayment(method, payment) {
    return await this.props.makePayment(method, payment);
  }

  render() {
    return (
      <>
        {this.state.status === true &&
          <>
            {this.state.payment === false &&
              <ButtonGroup size="sm" className="mb-3">
                {this.state.sdk.stripe &&
                  <Button onClick={()=>this.addPayment('stripe')}>Add Debit/Credit Card</Button>
                }
                {this.state.sdk.paypal &&
                  <Button onClick={()=>this.addPayment('paypal')}>Via Paypal</Button>
                }
              </ButtonGroup>
            }
            {this.state.payment === 'stripe' &&
              <Elements stripe={this.state.stripePromise} options={{
                mode: 'setup',
                currency: 'gbp',
                // Fully customizable with appearance API.
                appearance: {
                  labels: 'floating',
                  inputs: 'condensed',
                },
              }}>
                <StripePayment cancel={()=>this.addPayment(false)} />
              </Elements>
            }
            {this.state.payment === 'paypal' &&
              <PaypalPayment />
            }
            
            {this.state.payment === false &&
              <>
                {this.state.sdk.stripe&&<StripeCards sdk={this.state.sdk.stripe} order={this.props.order} payment={this.makePayment} />}
                {this.state.sdk.paypal&&<PaypalCards sdk={this.state.sdk.paypal} order={this.props.order} payment={this.makePayment} />}
              </>
            }

          </>
        }
      </>
    )
  }
}

export default PaymentModule;